export class ShareService {
    constructor(
        private shareButton: HTMLButtonElement | null,
        private printButton: HTMLButtonElement | null
    ) {
        if (this.shareButton) {
            this.shareButton.addEventListener("click", () => this.sharePage());
        }

        if (this.printButton) {
            this.printButton.addEventListener("click", () => this.onPrint());
        }
    }

    private async sharePage(): Promise<void> {
        try {
            if (navigator.share) {
                await navigator.share({
                    title: document.title,
                    url: window.location.href
                });
            } else {
                await navigator.clipboard.writeText(window.location.href);
                alert("Link ist kopiert!");
            }
        } catch (error) {
            console.error("Da ist ein Fehler aufgetreten:", error);
        }
    }

    private onPrint(): void {
        window.print();
    }
}

document.querySelectorAll<HTMLButtonElement>('.news-detail__play[data-scroll-target]').forEach((button) => {
    button.addEventListener('click', () => {
        const targetId = button.dataset.scrollTarget;
        if (!targetId) {
            return;
        }

        document.getElementById(targetId)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    });
});

new ShareService(
    document.querySelector(".news-detail__share"),
    document.querySelector(".news-detail__print")
);